import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import {Link} from 'react-router';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';
import { jobsRoute } from '../../routes/index';
import css from './jobs.scss';
import { formatNumber, DateFormatter } from '../../utils/date';
import forEach from 'lodash/forEach';
import translate from '../../utils/translate';
import metaDesc from '../../utils/meta';
import connect from '../../utils/connect';
import { genericRoute } from '../../routes';

import { fetchJobs } from '../../actions/jobs';

//import css from './editorial.scss';

class Jobs extends Component {

	constructor(props) {
		super(props);

		this.mounted = true;
		this.scrollHandler = this.scrollHandler.bind(this);

		this.state = {
			searchWord: '',
			searchResults: [],
			isSticky: false,
			stickAtPos: 0,
			stickyHeight: 0,
			headerHeight: 0,
		};
	}

	componentWillMount() {
		this.fetchJobs = bindActionCreators(fetchJobs, this.props.dispatch);

		this.fetchJobs();

		if (this.props.browser) {
			this.props.browser.scroll.register(this.scrollHandler);
		}
	}

	componentDidMount() {
		this.updateDimensions();
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.browser.window.width !== nextProps.browser.window.width) {
			this.updateDimensions();
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.jobs.items.length !== this.props.jobs.items.length ||
			nextState !== this.state
		);

		// update on init
		// if ((!this.props.items.length && nextProps.items.length)) {
		// 	return true;
		// }
	}

	componentWillUnmount() {
		this.mounted = false;
		if (this.props.browser) {
			this.props.browser.scroll.deregister(this.scrollHandler);
		}
	}

	render() {
		let jobs = this.props.jobs.items;
		let allJobs = 'All jobs';
		let jobsNum = jobs.length;

		let searchWord = this.state.searchWord;
		let searchResults = [];

		searchWord = searchWord.toLowerCase();

		forEach(jobs, function(job) {
			if (job.title.toLowerCase().indexOf(searchWord) > -1 || job.country.toLowerCase().indexOf(searchWord) > -1 || job.city.toLowerCase().indexOf(searchWord) > -1 || job.profiles.name && job.profiles.name.toLowerCase().indexOf(searchWord) > -1) {
				searchResults.push(job);
			}
		});

		if (searchWord != '') {
			jobsNum = searchResults.length;
			allJobs = 'Found jobs';

			if (!searchResults.length) {
				searchResults.push({
					title: 'No results',
				});
			}
		}

		let title = '';

		if (this.props.jobs.meta && this.props.jobs.meta.description !== this.metaDesc) {
			metaDesc(this.props.jobs.meta.description);
			this.metaDesc = this.props.jobs.meta.description;
			title = this.props.jobs.meta.title;
		}

		const stickyStyle = {};
		const placeholderStyle = {};

		if (this.state.isSticky) {
			placeholderStyle.height = this.state.stickyHeight;

			stickyStyle.position = 'fixed';
			stickyStyle.top = this.state.headerHeight;
			stickyStyle.height = this.state.stickyHeight;
			stickyStyle.zIndex = 1;
		}

		return (
			<div>
			<Helmet title={title} />
			{this.props.jobs && (
				<article className='jobs-list span14'>
					<div style={placeholderStyle}></div>
					<div className='jobs-list__sticky' ref='stickyElement' style={stickyStyle}>
						<div className='jobs-list__top span14'>
							<h1 className='jobs-list__top__title'>Jobs</h1>
							<span className='jobs-list__top__number'> ({jobs.length})</span>
							<Link to={genericRoute(false, 'submit/job')} className='button jobs-list__top__submit'>Post a job vacancy</Link>
						</div>
						<input onChange={(e) => this.onInput(e)} className='jobs-list__search span12 pixel-pattern hide-mobile' type='text' placeholder={translate('contextual/jobsSearch')}/>
						<div className='span2 jobs-list__right--small hide-mobile'>
							<span className='jobs-list__right__byline'>showing</span>
							<h2 className='jobs-list__right__title'>{allJobs}</h2>
							<span className='jobs-list__right__number'>{jobsNum + ' in total'}</span>
						</div>
					</div>
					<div className='jobs-list__flex'>
						<ul className='jobs-list__jobs span12 span14-mobile'>
							{(searchWord ? searchResults : jobs).map((job, i) => this.renderJob(job, i))}
						</ul>
						<div className='span2 jobs-list__right hide-mobile'></div>
					</div>
				</article>
			) || (
				<Spinner className='case-single__spinner' size='80px'></Spinner>
			)}
			</div>
		);
	}

	onInput(e) {
		this.setState({
			...this.state,
			searchWord: e.target.value,
		});
	}

	renderJob(job, i) {
		let uid = 'job-' + i;
		let date = new DateFormatter(job.createdDate);
		date = date.date + ' ' + date.month + ' ' + date.year;
		let url = jobsRoute(job.slug);

		return (
			<li key={uid} className='jobs-list__jobs__job span4 span6-tablet span14-mobile'>
				<h2 className='jobs-list__jobs__job__title'>{job.title}</h2>
				{job.profiles && job.profiles.name && (
				<span className='jobs-list__jobs__job__profile'>{job.profiles.name}</span>
				)}
				{job.city && (
				<span className='jobs-list__jobs__job__location'>{job.city + ', ' + job.country}</span>
				)}
				{job.createdDate && (
				<span className='jobs-list__jobs__job__date'>{date}</span>
				)}
				{job.slug && this.props.browser.window.width > 719 && (
				<div className='jobs-list__jobs__job__overlay'><Link to={url} className='button jobs-list__jobs__job__button'>Read more</Link></div>
				) || job.slug && (
				<Link to={url} className='jobs-list__jobs__job__button--fill'></Link>
				)}
			</li>
		);
	}

	updateDimensions() {
		const headerHeight = document.querySelector('.header-main').offsetHeight;
		const mainOffsetTop = this.refs.stickyElement ? this.refs.stickyElement.offsetTop : 0;
		const distanceToMenu = (mainOffsetTop - headerHeight) ? (mainOffsetTop - headerHeight) : 9999;

		const stickyHeight = (this.refs.stickyElement) ? this.refs.stickyElement.offsetHeight : 0;

		if (distanceToMenu === 9999) {
			setTimeout(() => {
				this.updateDimensions();
			}, 200);
		}

		this.mounted && this.setState({
			...this.state,
			stickAtPos: distanceToMenu,
			stickyHeight: stickyHeight,
			headerHeight: headerHeight,
		});
	}

	scrollHandler(e) {
		if (e.scrollY === this.prevSrollY) {
			return false; // noop
		} else {
			this.prevSrollY = e.scrollY;
		}

		const isMobile = (this.props.browser.window.width <= 719);
		const isSticky = (e.scrollY >= this.state.stickAtPos && !isMobile);

		if (this.state.stickyHeight <= 0 || this.state.stickAtPos <= 0) {
			return this.updateDimensions();
		}

		// stop setting state if not necessary
		if (this.state.isSticky === isSticky) {
			return false;  // noop
		}

		this.setState({
			...this.state,
			isSticky,
		});
	}
}

export default connect(Jobs);



/** WEBPACK FOOTER **
 ** ./frontend/containers/jobs/jobs.js
 **/